'use client'

import { useEffect } from 'react'

import { captureTracewayException, recordTracewayBreadcrumb } from '@/lib/traceway-breadcrumbs'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    recordTracewayBreadcrumb('navigation', 'global error boundary', {
      digest: error.digest ?? null,
      message: error.message,
      name: error.name,
    })
    void captureTracewayException(error, {
      boundary: 'global-error',
      digest: error.digest ?? null,
    })
  }, [error])

  return (
    <html lang="en">
      <body className="min-h-dvh bg-[radial-gradient(circle_at_top,_rgba(124,69,47,0.12),_transparent_40%),linear-gradient(180deg,#fbf7ef_0%,#f5ede0_100%)]">
        <div className="flex min-h-dvh items-center justify-center px-6">
          <div className="max-w-lg rounded-[2rem] border border-[rgba(116,102,70,0.18)] bg-[#fffdf8] p-6 text-center shadow-[0_20px_60px_rgba(91,78,43,0.12)]">
            <p className="text-sm font-semibold uppercase tracking-[0.2em] text-[#8b5a13]">Unexpected error</p>
            <h1 className="mt-3 text-3xl font-semibold text-[#2f2a22]">AskJyotish could not start.</h1>
            <p className="mt-3 text-sm leading-6 text-[#6a5c48]">
              The root app failed to render. Retry once the browser finishes loading, or refresh if this keeps happening.
            </p>
            <div className="mt-6 flex items-center justify-center gap-3">
              <button
                className="rounded-full bg-[#7c452f] px-4 py-2 text-sm font-semibold text-white shadow-[0_4px_16px_rgba(124,69,47,0.25)] transition hover:bg-[#6e3c28]"
                onClick={reset}
                type="button"
              >
                Try again
              </button>
            </div>
          </div>
        </div>
      </body>
    </html>
  )
}

